<div class="password-section fields" id="password-section-1">
  <app-input [type]="'password'" name="password" [(ngModel)]="userProfile.pass" (keyup)="inp_pass($event)"
    [formGroup]="authForm" label="Password *" [placeholder]="'Password'" required></app-input>
</div>
<div class="password-section fields" id="password-section-2">
  <app-input [type]="'password'" name="password2" [(ngModel)]="userProfile.pass2" [formGroup]="authForm"
    (keyup)="inp_pass2()" label="Confirm password *" [placeholder]="'Confirm password'" required></app-input>
  <span *ngIf="!isSamepass" class="l-form-input-error">
    <img class="samePass-valid-img" src="../../../../assets/icons/input-error-icon.png" alt="input-error-icon" />
    Please type same Password
  </span>
</div>
<div class="pass-strength" *ngIf="userProfile.pass">
  <div class="pass-strength-heading">Passwords must:</div>
  <div class="pass-strength-text">
    <span><img src="{{ pass_strength[pass_strength_param.min8] }}" alt="" class="pass-strength-check" />Be a minimum of
      8 characters</span>
    <span><img src="{{ pass_strength[pass_strength_param.lower] }}" alt="" class="pass-strength-check" />Include at
      least one lowercase letter (a-z)</span>
    <span><img src="{{ pass_strength[pass_strength_param.upper] }}" alt="" class="pass-strength-check" />Include at
      least one uppercase letter (A-Z)</span>
    <span><img src="{{ pass_strength[pass_strength_param.number] }}" alt="" class="pass-strength-check" />Include at
      least one number (0-9)</span>
    <span><img src="{{ pass_strength[pass_strength_param.special] }}" alt="" class="pass-strength-check" />Include at
      least one special character</span>
      <span><img src="{{ pass_strength[pass_strength_param.whiteSpace] }}" alt="" class="pass-strength-check" />Not contain leading or trailing whitespace</span>
  </div>
</div>
